import { type } from '@/utils/type'


export const POSITIONREMARQUABLE_REQUEST = type('POSITIONREMARQUABLE_REQUEST')
export const POSITIONREMARQUABLE_SUCCESS = type('POSITIONREMARQUABLE_SUCCESS')
export const POSITIONREMARQUABLE_ERROR = type('POSITIONREMARQUABLE_ERROR')

export const POSITIONREMARQUABLE_ENSURE_LIST = type('POSITIONREMARQUABLE_ENSURE_LIST')

export const POSITIONREMARQUABLE_SELECT_DETAIL_REQUEST = type('POSITIONREMARQUABLE_SELECT_DETAIL_REQUEST')
export const POSITIONREMARQUABLE_SELECT_DETAIL_SUCCESS = type('POSITIONREMARQUABLE_SELECT_DETAIL_SUCCESS')
export const POSITIONREMARQUABLE_SELECT_DETAIL_ERROR = type('POSITIONREMARQUABLE_SELECT_DETAIL_ERROR')
export const POSITIONREMARQUABLE_SELECT_DETAIL = type('POSITIONREMARQUABLE_SELECT_DETAIL')

export const POSITIONREMARQUABLE_SAVE_REQUEST = type('POSITIONREMARQUABLE_SAVE_REQUEST')
export const POSITIONREMARQUABLE_SAVE_SUCCESS = type('POSITIONREMARQUABLE_SAVE_SUCCESS')
export const POSITIONREMARQUABLE_SAVE_ERROR = type('POSITIONREMARQUABLE_SAVE_ERROR')

export const POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM = type('POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM')
export const POSITIONREMARQUABLE_CANCEL_MODIFIED_ADM = type('POSITIONREMARQUABLE_CANCEL_MODIFIED_ADM')

export const POSITIONREMARQUABLE_UPDATE_FILTER_ADM = type('POSITIONREMARQUABLE_UPDATE_FILTER_ADM')